<template>
    <div v-if="isPortrait" class="row" style="height: 100%;">

        <q-card class="my-card q-my-auto q-mx-xl q-px-xl q-py-xl" dark>
            <q-card-section class="text-center">
                <q-icon name="screen_rotation" color="white" size="60px"></q-icon>
            </q-card-section>
            <q-card-section class="text-center">
                Tournez votre appareil en orientation paysage pour afficher la vue employés.
            </q-card-section>
        </q-card>



    </div>
    <div class="c-dashboard-monthly"
        :class="{'-is-mobile' : isMobile}"
        :data-component-name="$options.name"
        v-else
    >
        <div class="c-dashboard__loading" v-if="$apollo.queries.userProfiles.loading || !showProjects">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div class="c-monthly-row -bg">
            <div class="c-monthly-cell -gap"></div>
            <div class="c-monthly-cell"
                v-bind:key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
            </div>
            <div class="c-monthly-cell -gap"></div>
        </div>

		<!-- FOOTER -->
        <MonthViewFooter
            :currentDate="currentDate"
            :monthrange="monthrange"
            :monthdays="monthdays"
            :isMobile="isMobile"
            @set-current-date="$emit('set-current-date', $event)"
            @set-more-filters="moreFilters=$event"
        />

        <div class="c-monthly-row">
            <div class="c-monthly-cell -gap" style="height: 30px;"><!-- NEEDED FOR 20PX GAP --></div>
            <div class="c-monthly-cell -name -order-by" style="height: 30px;">
                <div class="c-project__name u-text-truncate">
                    <OrderBy
                        :options="[
                            { value: 'name', label: 'Nom de l\'employé' },
                            { value: 'hiring_date', label: 'Date d\'embauche' },
                            { value: 'updated_at', label: 'Date de mise à jour' },
                            { value: 'created_at', label: 'Date de création' }
                        ]"
                        @update:orderBy="orderBy=$event.field;
                            orderSort=$event.sort;"
                        scope="staffView"
                    />
                </div>
            </div>
        </div>

        <div class="c-monthly-row__wrap" v-if="showProjects==true">
            <div
                v-bind:key="userProfile.id"
                v-for="userProfile in userProfilesList"
                :id="'userProfile'+userProfile.id"
            >
                <!-- <div
                    class="c-monthly-row"
                    v-if="userProfile.assignmentsSummary.datedAssignments.length>0 || userProfilesFilter=='All'"
                > -->
                <div
                    class="c-monthly-row"
                >
                    <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                    <div class="c-monthly-cell"
                        v-bind:key="index"
                        v-for="(monthday, index) in monthdays"
                        :class="[
                            {
                                '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                                '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6,
                            },
                            'week-'+userProfile.id+'-'+monthday.week
                        ]"
                        @mouseenter="addClass('.week-'+userProfile.id+'-'+monthday.week)"
                        @mouseleave="removeClass('.week-'+userProfile.id+'-'+monthday.week)"
                    >
                        <!-- <div class="c-project" v-if="userProfile.datedSummaries[monthday.dateStr]"
                            :class="userProfile.datedSummaries[monthday.dateStr].state"
                            @click="$emit('jump-to-project-week', {currentDate: monthday.dateStr, userProfileID: userProfile.id} )"
                        > -->
                        <div class="c-project" v-if="userProfile.datedSummaries[monthday.dateStr]"
                            :class="userProfile.datedSummaries[monthday.dateStr].state"
                        >
                            <div v-if="userProfile.datedSummaries[monthday.dateStr].state=='-summary-cell -draft'">
                                <UserProfileInfo iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="userProfile" :customContent="userProfile.datedSummaries[monthday.dateStr].totalHours" class="" :size="'16px'" />
                            </div>
                            <div v-else-if="userProfile.datedSummaries[monthday.dateStr].state=='-warning-absence' || userProfile.datedSummaries[monthday.dateStr].state=='-alert-absence'">
                                <span class="o-absence-type-dot__wrapper" v-if="userProfile.datedSummaries[monthday.dateStr].absences[0] && userProfile.datedSummaries[monthday.dateStr].absences[0].type && userProfile.datedSummaries[monthday.dateStr].absences[0].type.color && userProfile.datedSummaries[monthday.dateStr].absences[0].type.color!=''">
                                    <span class="o-absence-type-dot" :style="'background-color: '+ userProfile.datedSummaries[monthday.dateStr].absences[0].type.color">
                                    </span>
                                </span>
                                <UserProfileInfo iconname="event_busy" iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="userProfile" class="" :size="'16px'" />
                            </div>
                            <div v-else class="-summary-cell">
                                <!-- {{ userProfile.datedSummaries[monthday.dateStr].totalHours }} -->
                                <span>
                                    <span>
                                        <UserProfileInfo iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="userProfile" :customContent="userProfile.datedSummaries[monthday.dateStr].totalHours" class="" :size="'16px'" />
                                    </span>
                                </span>
                                <!-- {{ userProfile.datedSummaries[monthday.dateStr].ids }} -->

                                <div class="-progression" v-if="userProfile.datedSummaries[monthday.dateStr].state!='-completed'" :style="'width:'+userProfile.datedSummaries[monthday.dateStr].progression">
                                </div>
                                <!-- <div class="notifications-state__wrapper" > -->
                                    <div v-if="userProfile.datedSummaries[monthday.dateStr].nightShift">
                                        <q-icon name="brightness_2" class="-nightShift" />
                                        <q-tooltip>
                                            <div v-html="'Quart de travail de nuit'">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else class="q-mr-auto"></div>
                                    <div class="-auto-notifs" v-if="userProfile.datedSummaries[monthday.dateStr].assignments_summary_sent_at">
                                        <q-icon name="mail" />
                                        <q-tooltip>
                                            <div
                                                v-html="'Notification automatique (horaire) envoyée le ' + userProfile.datedSummaries[monthday.dateStr].assignments_summary_sent_at">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else-if="userProfile.datedSummaries[monthday.dateStr].notification_sent">
                                        <q-icon name="call_made" class="-manual-notifs" style="opacity: 0.6"/>
                                        <q-tooltip>
                                            <div v-html="'Notification manuelle envoyée le ' + userProfile.datedSummaries[monthday.dateStr].notification_sent"></div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else-if="userProfile.datedSummaries[monthday.dateStr].notification_pending">
                                        <q-icon name="notifications" class="-manual-notifs" />
                                        <q-tooltip>
                                            <div v-html="'Notification manuelle à envoyer'">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                <!-- </div> -->
                            </div>
                            <q-tooltip v-if="userProfile.datedSummaries[monthday.dateStr].tooltipStr">
                                <div v-html="userProfile.datedSummaries[monthday.dateStr].tooltipStr"></div>
                            </q-tooltip>
                            <!-- <pre>{{ userProfile.datedSummaries[monthday.dateStr] }}</pre> -->
                        </div>
                    </div>

                    <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                    <div class="c-monthly-cell -name">
                        <div class="c-project__category" :style="'border-color:' + userProfile.company.categories[0].color"
                            v-if="userProfile.company.categories.length"></div>
                        <div class="c-project__category" v-else style="border-right:none;"></div>
                        <div class="c-project__name u-text-truncate q-pl-md" v-if="!isMobile">
                            <div class="u-text-truncate">
                                {{ userProfile.name }}
                            </div>
                            <span>
                                <UserProfileInfo :currentDate="monthrange.str.from" :userProfile="userProfile" class="q-mr-xs" :size="'16px'" />
                            </span>
                        </div>
                        <div class="c-project__name u-text-truncate q-pl-md" v-else>
                            <!-- <div class="u-text-truncate">
                                {{ userProfile.name }}
                            </div> -->
                            <!-- <span> -->
                                <UserProfileInfo :currentDate="monthrange.str.from" :userProfile="userProfile" :customContent="userProfile.name" class="q-mr-xs u-text-truncate" :size="'16px'" />
                            <!-- </span> -->
                        </div>
                    </div>
                </div>

                <!-- <div class="c-dashboard-project" v-if="showProjectDetails==userProfile.id">
                    <ProjectForm class="c-dashboard-project__inner"
                        @refetch-userProfiles="refreshProject($event)"
                        @cancel="toggleProjectDetails(userProfile.id)"
                        v-bind:project="userProfile"
                        v-bind:weekrange="daterange"
                        :projectDetailsVisible="parseInt(projectDetailsVisible)"
                    />
                </div> -->
            </div>
            <div
                class="c-monthly-row"
                v-if="userProfiles && userProfiles.paginatorInfo.hasMorePages && !$apollo.queries.userProfiles.loading"
                ref="loadMoreProjects"
            >
                <div style="color: white"></div>
            </div>
        </div>
        <div class="c-monthly-row__wrap" v-else>
            <div class="-spacer"></div>
        </div>

		<div class="c-monthly-row -header" v-if="!this.isMobile">
            <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

            <div class="c-monthly-cell"
                v-bind:key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
                <div>
                    <div v-if="monthday.summary">{{ monthday.summary.count }}</div>
                    <div v-if="monthday.summary">{{ userProfilesList.length - monthday.summary.absences }}</div>
                </div>
            </div>
            <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>
        </div>
<!-- {{monthrange}} -->
    </div>
</template>

<script>
    // import ProjectForm from '@/components/forms/ProjectForm'
    import MonthViewFooter from "@/components/nav/MonthViewFooter";
    import {getDatesBetween, getMonthLimits, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import { USERPROFILESASSIGNMENTS } from '@/graphql/user/queries'
    import moment from 'moment';


    export default {
        name: 'StaffView',
        components: {
            MonthViewFooter,
            // ProjectForm
        },
        props: {
            projectIDs: {
                type: [Number, Array],
                default(){
                    return new Array()
                }
            },
            currentDate: String,
            projectsFilter: {
                type: String,
                default: 'All'
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showProjects: false,
                showProjectDetails: 0,
                projectDetailsVisible: 0,
                totalCount: {},
                monthdays: [],
                assignmentIDs: [],
                showAssignmentsDetails: false,
                pageSize: 50,
                loading: false,
                currentPage: 1,
                moreFilters: null,
                orderBy: 'name',
                orderSort: 'ASC',
                isPortrait: false,
            }
        },
        mounted() {
            this.$eventBus.$emit('clear-more-filters');
            this.monthdays=this.setMonthDays();

            this.$eventBus.$on('refresh-user-assignments', function(e){
                this.refreshUserAssignments(e.userProfileID);
            }.bind(this))

            // if (document.getElementById('app')) {
            //     this.isPortrait = document.getElementById('app').offsetWidth < 440
            // }

            let passiveSupported = false;
            try {
                const options = {
                    get passive() { 
                        passiveSupported = true;
                        return false;
                    }
                };

                window.addEventListener("test", null, options);
                window.removeEventListener("test", null, options);
            } catch(err) {
                passiveSupported = false;
            }
            document.addEventListener('scroll', this.onScroll, passiveSupported ? { passive: true } : false);
            window.addEventListener("resize", this.detectIfPortrait);
            this.detectIfPortrait();

        },
        beforeDestroy(){
            document.removeEventListener('scroll', this.onScroll);
            this.$eventBus.$off('refresh-user-assignments');
            window.removeEventListener("resize", this.detectIfPortrait);
        },
        computed: {
            userProfilesList(){
                if(!this.userProfiles || !this.userProfiles.data) return [];
                let userProfilesList = JSON.parse(JSON.stringify(this.userProfiles.data));
                this.setMonthDays(true);
                let summaries={};
                let daySummary = {};
                
                userProfilesList.forEach(function(userProfile){
                    let draftAssignmentIDs = [];
                    userProfile.datedSummaries={}
                    let userDaySummarySetted = {};

                    userProfile.assignments.forEach(function(assignment){
                        let date = assignment.date
                        if (!userDaySummarySetted[date]) {
                            daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                            userDaySummarySetted[date] = true;
                            if (daySummary[date]) daySummary[date].summary.count += 1;
                        }
                        if (!userProfile.datedSummaries[date]) userProfile.datedSummaries[date] = { ids: [], assignments: [], draftAssignments: [], absences: [], notification_pending: false, notification_sent: false, assignments_summary_sent_at: false, progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                        // if(!userProfile.datedSummaries[date].assignments) userProfile.datedSummaries[date].assignments=[]
                        if (!userProfile.datedSummaries[date].notification_sent) userProfile.datedSummaries[date].notification_sent = assignment.notification_sent_at
                        if (!userProfile.datedSummaries[date].notification_pending) userProfile.datedSummaries[date].notification_pending = assignment.notification_pending;
                        if (!userProfile.datedSummaries[date].assignments_summary_sent_at) userProfile.datedSummaries[date].assignments_summary_sent_at = assignment.assignments_summary_sent_at;
                        userProfile.datedSummaries[date].assignments.push(assignment);
                        draftAssignmentIDs.push(assignment.draft_assignment_id)
                    }.bind(this))

                    userProfile.draftAssignments.forEach(function(assignment){
                        if(!draftAssignmentIDs.includes(assignment.id)) {
                            let date=assignment.date
                            if(!userProfile.datedSummaries[date]) userProfile.datedSummaries[date]={ids: [], assignments: [], draftAssignments: [], absences: [], progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                            userProfile.datedSummaries[date].draftAssignments.push(assignment);

                            if (!userDaySummarySetted[date]) {
                                daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                                userDaySummarySetted[date] = true;
                                if (daySummary[date]) daySummary[date].summary.count += 1;
                            }

                        }
                    }.bind(this))

                    userProfile.absences.forEach(function(absence){
                        let date=absence.date
                        if(!userProfile.datedSummaries[date]) userProfile.datedSummaries[date]={ids: [], assignments: [], draftAssignments: [], absences: [], progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                        userProfile.datedSummaries[date].absences.push(absence);

                        daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                        if (daySummary[date]) daySummary[date].summary.absences += 1;

                    }.bind(this))

                    userProfile.datedSummaries = this.getSummaryState(userProfile.datedSummaries, userProfile.name);
                }.bind(this))
                this.monthdays.forEach(function(monthday, key){
                    if(summaries[monthday.dateStr]){
                        // this.monthdays[key].summary=Object.assign({}, summaries[monthday.dateStr]);
                        this.monthdays[key].summary=this.getSummaryState(summaries[monthday.dateStr]);
                    }
                }.bind(this))

                return userProfilesList;
            },
            monthrange(){
                return getMonthLimits(this.currentDate)
            },
            daterange() {
                let length = 41
                let offset = -5
                if (this.isMobile) {
                    length = 16
                    offset = -5
                    if (this.isPortrait) {
                        offset = -4
                        length = 9
                    }
                }
                return getMonthLimits(this.currentDate, length, offset)
            },
            monthWeeks(){
                let monthWeeks=[];
                let starting=true;
                let i=-1;
                this.monthdays.forEach(function(monthday){
                    if(monthday.date.getDay()==0 || starting){
                        i++;
                        monthWeeks[i]=[];
                    }
                    monthWeeks[i].push(monthday);
                    starting=false;
                })

                return monthWeeks;
            }
        },
        methods: {
            detectIfPortrait() {
                if (document.getElementById('app')) {
                    this.isPortrait = document.getElementById('app').offsetWidth < 440
                    return;
                }
            },

            refreshUserAssignments(userProfileID){
                if(!userProfileID) return;
                let variables={};
                if(this.daterange) variables.dateRange=this.daterange.str;
                if(this.daterange) variables.shiftsDateRange=this.daterange.str;
                if(this.projectIDs.length>0) variables.ids=this.projectIDs;
                variables.ids=[userProfileID];
                variables.first=1;

                this.$apollo.query({
                    query: USERPROFILESASSIGNMENTS,
                    fetchPolicy: 'network-only',
                    variables: {
                        ...variables
                    },
                }).then(() => {
                    //quedalle
                })
            },
            addClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.add('hover')
                })
            },
            removeClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.remove('hover')
                })
            },
            getSummaryState(datedSummaries, userProfileName){
                // let state='', tooltips=[];
                // summary.tooltipStr='';
                Object.keys(datedSummaries).forEach(function(date){
                    let tooltips=[];
                    datedSummaries[date].assignments.forEach(function(assignment){
                        let start=moment(assignment.date+'T'+assignment.start_time),
                        end=moment(assignment.date+'T'+assignment.end_time),
                        isAlert=false;
                        datedSummaries[date].ids.push(assignment.id);

                        if(end<=start){
                            end=end.add(1, 'days');
                            datedSummaries[date].nightShift=true;
                        }
                        let hours=moment.duration(end.diff(start)).asHours()


                        if(assignment.deniedByUser){
                            datedSummaries[date].state='-alert'
                            tooltips.push("L'affectation "+assignment.id+" a été refusée par "+assignment.accepted_by.name)
                            isAlert=true;
                        }

                        if(assignment.maybeByUser){
                            datedSummaries[date].state='-published'
                            // tooltips.push("L'affectation "+assignment.id+" a été refusée par "+assignment.accepted_by.name)
                            tooltips.push(assignment.accepted_by.name+" a répondu peut-être à l'affectation "+assignment.id)
                            isAlert=true;
                        }

                        if(!isAlert){
                            datedSummaries[date].totalHours=Math.round((parseInt(datedSummaries[date].totalHours)+parseInt(hours))*10)/10;

                            if(!assignment.accepted_by && datedSummaries[date].state!='-alert'){
                                datedSummaries[date].state="-published"
                            }

                        }

                    })

                    datedSummaries[date].draftAssignments.forEach(function(assignment){
                        let start=moment(assignment.date+'T'+assignment.start_time),
                            end=moment(assignment.date+'T'+assignment.end_time);
                        // isAlert=false;
                        datedSummaries[date].ids.push(assignment.id);

                        if(end<=start){
                            end=end.add(1, 'days');
                            datedSummaries[date].nightShift=true;
                        }
                        let hours=moment.duration(end.diff(start)).asHours()

                        if(datedSummaries[date].assignments.length){
                            datedSummaries[date].state=datedSummaries[date].state+' -hasdraft';
                        }
                        tooltips.push("Cette journée contient des informations non publiées pour le projet «"+assignment.project.name + "» / quart de travail «"+assignment.projectShift.name+"»")
                        if(!datedSummaries[date].assignments.length) datedSummaries[date].state='-draft';


                        datedSummaries[date].totalHours=Math.round((parseInt(datedSummaries[date].totalHours)+parseInt(hours))*10)/10;

                    })

                    if(datedSummaries[date].absences && datedSummaries[date].absences.length>0){
                        if(datedSummaries[date].assignments && datedSummaries[date].assignments.length>0){
                            datedSummaries[date].state='-alert-absence';
                            tooltips.push(userProfileName+" est affecté(e) "+datedSummaries[date].totalHours+" heures lors d'une journée d'absence : "+ datedSummaries[date].absences[0].type.name)
                        }else{
                            datedSummaries[date].state='-warning-absence';
                            tooltips.push(userProfileName+" est absent(e) cette journée : " + datedSummaries[date].absences[0].type.name)
                        }
                        datedSummaries[date].totalHours=-1
                    }
                    
                    if(tooltips.length>0){
                        datedSummaries[date].tooltipStr='• '+tooltips.join('<br>• ');
                    }

                }.bind(this))
                return datedSummaries;
            },
            setMonthDays(setIt = false){
                let monthdays=[]
                let dateRange=getDatesBetween(this.daterange.obj.from, this.daterange.obj.to)
                let starting=true;
                let week=-1;
                dateRange.forEach(function(date){
                    if(date.getDay()==this.$generalSettings.settings.firstDayOfWeek || starting){
                        week++;
                        starting=false;
                    }
                    monthdays.push({
                        totalOccupation: 0,
                        date: date,
                        dateStr: moment(date).format('YYYY-MM-DD'),
                        day: dayStr(date.getDate()),
                        week: week,
                        dayOfWeekStr: dayOfWeekStr(date),
                        monthStr: monthStr(date),
                        summary: {
                            count: 0,
                            draftCount: 0,
                            unassigned: 0,
                            absences: 0,
                            state: ''
                        }
                    })
                }.bind(this))
                if (setIt) this.monthdays = monthdays;

                return monthdays;
            },
            onScroll(){
                // clearTimeout(this.bodyScrollTo);
                // this.bodyScrollTo = setTimeout(function(){
                    var loadMoreEl = this.$refs["loadMoreProjects"];
                    // var loadMoreParent = document.body;
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = (window.innerHeight || document.documentElement.clientHeight)
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreUserProfiles()
                        }
                    }
                // }.bind(this), 300)
            },
            getMoreUserProfiles(){
                this.$nextTick(function(){
                    if (this.loading || !this.userProfiles.paginatorInfo.hasMorePages) return;
                    
                    this.$apollo.queries.userProfiles.fetchMore({
                        variables: {
                            page: this.userProfiles.paginatorInfo.currentPage+1,
                            // page: this.currentPage,
                            first: this.pageSize,
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            let data = {}
                            data.userProfiles={
                                __typename: fetchMoreResult.userProfiles.__typename,
                                // data: [...previousResult.userProfiles.data, ...fetchMoreResult.userProfiles.data],
                                data: [...this.userProfiles.data, ...fetchMoreResult.userProfiles.data],
                                paginatorInfo: fetchMoreResult.userProfiles.paginatorInfo
                            }
                            return data
                        },
                    })
                })
            }
        },
        watch: {
            daterange: function(){
                // this.userProfiles=null;
                this.projectDetailsVisible=0
                this.showProjectDetails=0
                this.currentPage=1
                this.monthdays=this.setMonthDays();
                this.showProjects=false
                setTimeout(function(){
                    if(!this.$apollo.queries.userProfiles.loading) this.showProjects=true
                }.bind(this), 550)
            },
            loading: function(){
                if(this.loading) return
                this.$nextTick(function(){
                    this.onScroll()
                })
            },
        },
        apollo: {
            userProfiles: {
                query: USERPROFILESASSIGNMENTS,
                fetchPolicy: 'network-only',
                // fetchPolicy: 'cache-and-network',
                debounce: 500,
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    let variables={};
                    if(this.daterange) variables.dateRange=this.daterange.str
                    if(this.daterange) variables.shiftsDateRange=this.daterange.str
                    if (this.moreFilters) {
                        variables.moreFilters = this.moreFilters
                        if (this.daterange) variables.moreFilters.dateRange = this.daterange.str
                        if (this.moreFilters.projects?.length > 0) variables.projects = this.moreFilters.projects
                    }
                    if (this.orderBy) {
                        variables.orderBy = this.orderBy
                    }
                    if (this.orderSort) {
                        variables.orderSort = this.orderSort
                    }

                    variables.first=this.pageSize;
                    variables.page = 1;
                    variables.limitStaff = true;
                    
                    if(variables){
                        return {...variables}
                    }
                },
                update(data) {
                    this.showProjects=true
                    return data.userProfiles;
                },
            }
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/dashboard/MonthView.scss";

    .-summary-cell {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &>span {
            width: 100%;
            height: 100%;
            display: flex;

            &>span {
                flex-grow: 1;
                align-content: center;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                // color: white;
                font-size: 0.9rem;
                // padding-bottom: 6px;
            }
        }
    
    }
    
    .c-monthly-cell .c-project .-userprofile-info__toggle {
        color: black !important;
    }

    .o-absence-type-dot {
        
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        right: -4px;

        &__wrapper {
            position: absolute;
            height: 6px;
            width: 16px;
            top: 6px;
            display: block;
            overflow: visible;
        }
    }
</style>
